/* SUBSCRIPTION QUERY PARAMS */
/*
Used to auto populate coupon input field and
propagate coupon through the subscription flow for reporting
 */
export const COUPON_QUERY_PARAM = 'coupon';

/*
 Used to indicate the source from which the subscription was triggered
 */
export const SOURCE_QUERY_PARAM = 'source';

/*
 Used to override the hero image on the couponcode landing page
 */
export const SOURCE_IMAGE_URL_QUERY_PARAM = 'sourceimageurl';

/*
 Used to indicate a discount/strike through price should be displayed
 through the subscription flow
 */
export const DISCOUNT_QUERY_PARAM = 'discount';

/*
 In web we use these keys to redirect the user to the content
 they were on previously after they complete the subscription flow.
 We also pass in the guideId to subscribe category action logs.
 We originally implemented as a part of deep linking,
 - may still be used in that context or utm tracking
 see: https://confluence.tunein.com/display/PRODSPECS/Premium+Deep+Link+Query+String+Params
 */
export const BROWSE_QUERY_PARAM = 'browse';

export const PROFILE_QUERY_PARAM = 'profile';

export const NO_PAYMENT_SKU = 'npsku';

export const SELECTED_SKU_QUERY_PARAM = 'ss';

export const REDIRECT_URI_QUERY_PARAM = 'redirect_uri';

export const IMMEDIATE_REDIRECT_QUERY_PARAM = 'immediate_redirect';

export const TOKEN_REQUIRED_QUERY_PARAM = 'tr';

export const TOKEN_QUERY_PARAM = 'token';

/*
  Used to specify a redirect that should ONLY happen in app
 */
export const IN_APP_REDIRECT = 'in_app_redirect';

/*
 Used to denote that user is in Pairing Auth Flow and specify the flow type (qr | pin)
 */
export const PAIR_AUTH_FLOW = 'pairauthflow';

export const PARTNER_ID = 'partnerid';

/*
 Used to denote a usercode (i.e. pincode) in Pairing Auth Flow
 can appear via a qr generated deeplink or can be manually entered via user as a pincode
 */
export const USER_CODE = 'usercode';
